var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImages(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1726_22615)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.3333 30.6667V31.7778C33.3333 33.6187 31.841 35.1111 30 35.1111H3.33333C1.49236 35.1111 0 33.6187 0 31.7778V14C0 12.159 1.49236 10.6667 3.33333 10.6667H4.44444V14H3.75C3.51988 14 3.33333 14.1865 3.33333 14.4167V31.3611C3.33333 31.5912 3.51988 31.7778 3.75 31.7778H29.5833C29.8134 31.7778 30 31.5912 30 31.3611V30.6667H33.3333ZM36.25 7.33333H10.4167C10.1865 7.33333 9.99999 7.51988 9.99999 7.75V24.6944C9.99999 24.9246 10.1865 25.1111 10.4167 25.1111H36.25C36.4801 25.1111 36.6666 24.9246 36.6666 24.6944V7.75C36.6666 7.51988 36.4801 7.33333 36.25 7.33333ZM36.6666 4C38.5076 4 40 5.49236 40 7.33333V25.1111C40 26.9521 38.5076 28.4444 36.6666 28.4444H9.99999C8.15902 28.4444 6.66666 26.9521 6.66666 25.1111V7.33333C6.66666 5.49236 8.15902 4 9.99999 4H36.6666ZM18.3333 11.7778C18.3333 13.3119 17.0896 14.5555 15.5555 14.5555C14.0214 14.5555 12.7778 13.3119 12.7778 11.7778C12.7778 10.2437 14.0214 9 15.5555 9C17.0896 9 18.3333 10.2437 18.3333 11.7778ZM13.3333 18.4444L16.0774 15.7003C16.4028 15.3749 16.9305 15.3749 17.256 15.7003L20 18.4444L27.1885 11.2559C27.5139 10.9305 28.0416 10.9305 28.3671 11.2559L33.3333 16.2222V21.7778H13.3333V18.4444Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1726_22615"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 35.5556,
    transform: "translate(0 2)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImages);
export default __webpack_public_path__ + "static/media/images.d1bdba7dff7f6ef2a4bad2905a1e4e96.svg";
export { ForwardRef as ReactComponent };